import * as React from 'react';
import { Text, Modal, Image, Box, MessageBoxFunctionalLayout } from 'wix-style-react';
import { translate, InjectedTranslateProps } from 'react-i18next';
import { DataHooks } from '@src/constants/data-hooks';
import { withBIModalEvents, ModalProps } from '@src/components/with-bi-modal-events/with-bi-modal-events';
import { PopupType } from '@src/context/actions/bi';

import successImage from './success-image.svg';

type Props = ModalProps & InjectedTranslateProps & { isOpen: boolean };
const SuccessPromptComponent = translate()(({ t, isOpen, onOk, onCancel }: Props) => (
  <Modal dataHook={DataHooks.SaveSuccessModal} isOpen={isOpen} onRequestClose={onCancel} shouldCloseOnOverlayClick>
    <MessageBoxFunctionalLayout
      dataHook={DataHooks.SaveSuccessPrompt}
      confirmText={t('save.and.publish.success.live-site')}
      onOk={onOk}
      cancelText={t('save.and.publish.success.close')}
      onCancel={onCancel}
      onClose={onCancel}
      title={t('save.and.publish.success.title')}
      width="600px"
    >
      <Box>
        <Box>
          <Image width="186px" src={successImage} />
        </Box>
        <Box marginLeft="36px">
          <Text>
            {t('save.and.publish.success.message')}
            <br />
            <br />
            {t('save.and.publish.success.note')}
          </Text>
        </Box>
      </Box>
    </MessageBoxFunctionalLayout>
  </Modal>
));

export const SuccessPrompt = withBIModalEvents(PopupType.Published)(SuccessPromptComponent);
